<template>
  <form @submit.prevent="formSubmit">
    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="form-group basic">
          <div class="input-wrapper">
            <label class="label" for="form-blocking-asset">Activo</label>
            <select class="form-control custom-select" id="form-blocking-asset" v-model="assetSelected" required>
              <template v-for="(asset, a_i) in portfolio" v-bind:key="'form-blocking-asset-'+a_i">
                <option :value="a_i" v-if="this.portfolio[a_i].networks_locked.length > 0">
                  {{asset.name}} ({{asset.symbol}})
                </option>
              </template>
            </select>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-sm-12">
        <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="account1">Red de bloqueo</label>
                <select class="form-control custom-select" id="form-blocking-network" v-model="networkSelected" required>
                    <option v-for="(network, n_i) in networks" v-bind:key="'form-blocking-network-'+n_i" :value="n_i">
                        {{network.network.name}} ({{ $root.recortarCadena(network.contract_address) }})
                    </option>
                </select>
            </div>
        </div>
      </div>
    </div>
    
    <div class="form-group basic">
      <label class="label" v-if="asset != null">Ingrese Cantidad - Balance: {{network.balance}} {{ asset.symbol }}</label>
        <div class="input-group mb-2">
          <span class="input-group-text" id="basic-addonb1">{{asset.symbol}}</span>
            <input type="text" class="form-control" placeholder="Ingrese una cantidad" v-model="form.amount" required />
        </div>
    </div>

    <ul class="nav nav-tabs capsuled" role="tablist">
        <li class="nav-item" v-for="(fee, f) in options.fee" v-bind:key="'bfee-'+f">
            <a :class="'nav-link ' + (f == form.fee ? ' active' : '')" data-bs-toggle="tab" :href="'#bfee-'+f" role="tab" @click="form.fee=f;form.time_lock=fee.time_lock">
                {{ fee.name }}
            </a>
        </li>
    </ul>

    <div class="table-responsive" style="zoom: 0.8;">
      <table class="table schule">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Lunes</th>
            <th scope="col">Martes</th>
            <th scope="col">Miercoles</th>
            <th scope="col">Jueves</th>
            <th scope="col">Viernes</th>
            <th scope="col">Sabado</th>
            <th scope="col">Domingo</th>
            <th scope="col">Lunes</th>
            <th scope="col">Martes</th>
            <th scope="col">Miercoles</th>
          </tr>
        </thead>
        <tbody>
          <tr :class="formatoFecha == 'lunes' ? 'table-primary' : 'table-secondary'">
            <th scope="row">Lunes</th>
            <td>0</td>
            <td :class="(formatoFecha == 'lunes' && form.time_lock == (1440)) ? 'table-success-2' : ''"><a @click="form.fee=0;form.time_lock=(1440)">24</a></td>
            <td :class="(formatoFecha == 'lunes' && form.time_lock == (1440*2)) ? 'table-success-2' : ''"><a @click="form.fee=1;form.time_lock=(1440*2)">48</a></td>
            <td :class="(formatoFecha == 'lunes' && form.time_lock == (1440*3)) ? 'table-success-2' : ''"><a @click="form.fee=2;form.time_lock=(1440*3)">72</a></td>
            <td colspan="6"></td>
          </tr>
          <tr :class="formatoFecha == 'martes' ? 'table-primary' : 'table-secondary'">
            <th scope="row">Martes</th>
            <td></td>
            <td>0</td>
            <td :class="(formatoFecha == 'martes' && form.time_lock == (1440)) ? 'table-success-2' : ''"><a @click="form.fee=0;form.time_lock=(1440)">24</a></td>
            <td :class="(formatoFecha == 'martes' && form.time_lock == (1440*2)) ? 'table-success-2' : ''"><a @click="form.fee=1;form.time_lock=(1440*2)">48</a></td>
            <td :class="(formatoFecha == 'martes' && form.time_lock == (1440*3)) ? 'table-success-2' : ''"><a @click="form.fee=2;form.time_lock=(1440*3)">72</a></td>
            <td colspan="5"></td>
          </tr>
          <tr :class="formatoFecha == 'miércoles' ? 'table-primary' : 'table-secondary'">
            <th scope="row">Miércoles</th>
            <td colspan="2"></td>
            <td>0</td>
            <td :class="(formatoFecha == 'miércoles' && form.time_lock == (1440)) ? 'table-success-2' : ''"><a @click="form.fee=0;form.time_lock=(1440)">24</a></td>
            <td :class="(formatoFecha == 'miércoles' && form.time_lock == (1440*2)) ? 'table-success-2' : ''"><a @click="form.fee=1;form.time_lock=(1440*2)">48</a></td>
            <td colspan="2"></td>
            <td :class="(formatoFecha == 'miércoles' && form.time_lock == (1440*3)) ? 'table-success-2' : ''"><a @click="form.fee=2;form.time_lock=(1440*3)">72</a></td>
            <td colspan="2"></td>
          </tr>
          <tr :class="formatoFecha == 'jueves' ? 'table-primary' : 'table-secondary'">
            <th scope="row">Jueves</th>
            <td colspan="3"></td>
            <td>0</td>
            <td :class="(formatoFecha == 'jueves' && form.time_lock == (1440)) ? 'table-success-2' : ''"><a @click="form.fee=0;form.time_lock=(1440)">24</a></td>
            <td colspan="2"></td>
            <td :class="(formatoFecha == 'jueves' && form.time_lock == (1440*2)) ? 'table-success-2' : ''"><a @click="form.fee=1;form.time_lock=(1440*2)">48</a></td>
            <td :class="(formatoFecha == 'jueves' && form.time_lock == (1440*3)) ? 'table-success-2' : ''"><a @click="form.fee=2;form.time_lock=(1440*3)">72</a></td>
            <td></td>
          </tr>
          <tr :class="formatoFecha == 'viernes' ? 'table-primary' : 'table-secondary'">
            <th scope="row">Viernes</th>
            <td colspan="4"></td>
            <td>0</td>
            <td colspan="2"></td>
            <td :class="(formatoFecha == 'viernes' && form.time_lock == (1440)) ? 'table-success-2' : ''"><a @click="form.fee=0;form.time_lock=(1440)">24</a></td>
            <td :class="(formatoFecha == 'viernes' && form.time_lock == (1440*2)) ? 'table-success-2' : ''"><a @click="form.fee=1;form.time_lock=(1440*2)">48</a></td>
            <td :class="(formatoFecha == 'viernes' && form.time_lock == (1440*3)) ? 'table-success-2' : ''"><a @click="form.fee=2;form.time_lock=(1440*3)">72</a></td>
          </tr>
          <tr :class="formatoFecha == 'sábado' ? 'table-primary' : 'table-secondary'">
            <th scope="row">Sábado</th>
            <td colspan="4"></td>
            <td>0</td>
            <td colspan="2"></td>
            <td :class="(formatoFecha == 'sábado' && form.time_lock == (1440)) ? 'table-success-2' : ''"><a @click="form.fee=0;form.time_lock=(1440)">24</a></td>
            <td :class="(formatoFecha == 'sábado' && form.time_lock == (1440*2)) ? 'table-success-2' : ''"><a @click="form.fee=1;form.time_lock=(1440*2)">48</a></td>
            <td :class="(formatoFecha == 'sábado' && form.time_lock == (1440*3)) ? 'table-success-2' : ''"><a @click="form.fee=2;form.time_lock=(1440*3)">72</a></td>
          </tr>
          <tr :class="formatoFecha == 'domingo' ? 'table-primary' : 'table-secondary'">
            <th scope="row">Domingo</th>
            <td colspan="4"></td>
            <td>0</td>
            <td colspan="2"></td>
            <td :class="(formatoFecha == 'domingo' && form.time_lock == (1440)) ? 'table-success-2' : ''"><a @click="form.fee=0;form.time_lock=(1440)">24</a></td>
            <td :class="(formatoFecha == 'domingo' && form.time_lock == (1440*2)) ? 'table-success-2' : ''"><a @click="form.fee=1;form.time_lock=(1440*2)">48</a></td>
            <td :class="(formatoFecha == 'domingo' && form.time_lock == (1440*3)) ? 'table-success-2' : ''"><a @click="form.fee=2;form.time_lock=(1440*3)">72</a></td>
          </tr>
          <!-- <tr>
            <th scope="row">Sabado</th>
            <td colspan="10"></td>
          </tr>
          <tr>
            <th scope="row">Domingo</th>
            <td colspan="10"></td>
          </tr> -->
        </tbody>
      </table>
    </div>
    
    <div class="form-group basic-">
        <div class="tab-content mt-1">
            <div :class="'tab-pane fade' + (f == form.fee ? ' active show' : '')" :id="'bfee-'+f" role="tabpanel" v-for="(fee, f) in options.fee" v-bind:key="'bfee-'+f">
              <h3 class="text-end">{{ fee.description }}</h3>
              <hr>
              <table class="table">
                <tbody>
                  <tr>
                    <th>Cantidad:</th>
                    <td>{{ parseFloat(form.amount) }} {{ asset.symbol }}</td>
                  </tr>
                  <tr>
                    <th>~Comision:</th>
                    <td>{{ comision }} {{ asset.symbol }}</td>
                  </tr>
                  <tr>
                    <th>Subtotal:</th>
                    <td>{{ subtotal }} {{ asset.symbol }}</td>
                  </tr>
                  <tr class="table-secondary">
                    <th>Total:</th>
                    <td>{{ total }} {{ asset.symbol }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
    </div>

    <div class="form-group basic">
      <button type="submit" :disabled="sending" class="btn btn-primary btn-block btn-lg">Continuar</button>
    </div>
  </form>
</template>

<!-- //
<template>
    <form @submit.prevent="formSubmit">



    </form>
</template>
-->

<style>
table.schule {
  tr td {
    text-align: center;
    a {
      cursor: pointer;
    }
  }
}
.table-success-2 {
  background-color: darkgreen !important;
  color: white !important;
}
</style>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'HomeView',
  data() {
    return {
      sending: false,
      assetSelected: 0,
      networkSelected: 0,
      // networks: [],
      formatoFecha: '',
      form: {
        asset: 0,
        amount: '',
        time_lock: 1440,

        fee: 0,
        bank: 0,
      },
      options: {
        fee: [
          {
            name: '24 Horas',
            description: 'Gana hasta 1%',
            type_fee: 'percentage',
            fee: '1',
            time_lock: 1440,
          },
          {
            name: '48 Horas',
            description: 'Gana hasta 2% y 3% en 48 horas',
            type_fee: 'percentage',
            fee: '2',
            time_lock: 2882,
          },
          {
            name: '72 Horas',
            description: 'Gana hasta 4% y 5% en 72 horas',
            type_fee: 'percentage',
            fee: '4',
            time_lock: 4323,
          },
          // {
          //   name: '2 minutos',
          //   description: 'Gana hasta el 1% (Solo desarrollo)',
          //   type_fee: 'percentage',
          //   fee: '1',
          //   time_lock: 2,
          // },
          // acfbc43e1a206be300f5828ca7f82197e294bc831adc53081ae71d87827da454
          // 00000000000000000000000000000000000000000000000000000000401332c0
          // 00000000000000000000000000000000000000000000000000000000678ef075
        ]
      }
    };
  },
  watch: {
  },
  computed: {
    ...mapState(['portfolio']),
    network() {
      return this.networks[this.networkSelected] ?? null;
    },
    asset() {
      return this.portfolio[this.assetSelected] ?? null;
    },
    networks() {
      return this.portfolio[this.assetSelected].networks_locked;
    },
    subtotal() {
      return parseFloat(this.form.amount) ?? 0;
    },
    comision() {
      if (this.fee !== null) {
        if (this.fee.type_fee == 'percentage') {
          return (parseFloat(this.form.amount) * parseFloat(this.fee.fee)) / 100;
        }
        else if (this.fee.type_fee == 'amount') {
          return this.fee.fee;
        }
      }
      return 999999999;
    },
    feetotal() {
      return parseFloat(this.comision) ?? 0;
    },
    total() {
      return (this.subtotal + this.feetotal) ?? 0;
    },
    fee() {
      return this.options.fee[this.form.fee] ?? null;
    },
  },
  methods: {
    ...mapActions(['newNotification', 'createSellAPI', 'v1_getLastLocked']),
    /* eslint-disable */
    async formSubmit() {
      const self = this
      console.log('formSubmit', this.asset)
      this.sending = true;

      const responseLast = await this.v1_getLastLocked();
      console.log('responseLast', responseLast)
      if (responseLast.result == 'success') {
        if (parseFloat(this.network.balance) < parseFloat(this.form.amount)) {
          self.$swal.fire({
            title: "Fondos insuficientes",
            text: "No tienes fondos para esta transaccion.",
            icon: "error",
            draggable: false,
          }).then((result) => {
            this.sending = false;
            if (result.isConfirmed) {}
          });
          this.sending = false;
          return false;
        } else {
          
          self.$swal.fire({
            title: "Saldo encontrado!",
            text: "Tu saldo a bloquear es " + this.form.amount + " " + self.asset.symbol,
            icon: "success",
            draggable: false,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, continuar!",
            cancelButtonText: "Cancelar"
          }).then((result) => {
            if (result.isConfirmed) {
              const data = {
                network_id: this.assetSelected,
                asset_id: this.assetSelected,
                amount: this.form.amount,
                time_lock: this.form.time_lock,
              }
              console.log('data', data)
              
              this.sending = false;
              location.replace(`/verify/blocking/${data.network_id}/${data.asset_id}/${data.amount}/${data.time_lock}`)
            }
          });
        }
      } else {
        
        self.$swal.fire({
          title: "Error!",
          text: responseLast.message,
          icon: "error",
          draggable: false,
        }).then((result) => {
          this.sending = false;
          if (result.isConfirmed) {}
        });
        
        this.sending = false;
      }
      return false;
    },
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
    
    // Crea una nueva fecha
    const fecha = new Date();

    // Usa Intl.DateTimeFormat para obtener el nombre del día en la zona horaria 'America/Bogota'
    const options = {
      timeZone: 'America/Bogota',
      weekday: 'long'  // Obtiene el nombre completo del día (Lunes, Martes, etc.)
    };

    const formatoFecha = new Intl.DateTimeFormat('es-CO', options).format(fecha);
    console.log('Día de la semana:', formatoFecha);
    this.formatoFecha = formatoFecha;

  },
}
</script>